<dx-check-box
  stylingMode="filled"
  valueChangeEvent="keyup input change"
  [text]="text"
  [(value)]="value"
  [readOnly]="!isEditing"
  [elementAttr]="{ class: 'form-editor' }"
  (onValueChanged)="valueChanged($event)"
>
  <dx-validator [validationRules]="validators"></dx-validator>
</dx-check-box>
